import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type onLeapQueryCandidateClickedArgs = {
	candidateIndex: number;
	titleIndex: number;
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};

export const onLeapQueryCandidateClicked = ({
	candidateIndex,
	titleIndex,
	commonAttributes,
	nonPrivacySafeAttributes,
}: onLeapQueryCandidateClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: `${ACTION_SUBJECT_PREFIX}LeapQueryCandidate`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			leapQueryCandidateIndex: candidateIndex,
			lastQueryTitleIndex: titleIndex,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
